import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import {
  createCommercials,
  updateCommercials,
} from "../../../store/slices/commericals";
import Select from "react-select";
import { getAllPrograms } from "../../../store/slices/programsSlice";
import { getAllServices } from "../../../store/slices/servicesSlice";
import { getAllSubServices } from "../../../store/slices/subServicesSlice";
import { getCategories } from "../../../store/slices/categories";

const CommercialFormModal = ({
  isOpen,
  toggle,
  pagination,
  commercialData,
}) => {
  const serviceFormRef = useRef();
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState({
    plan_id: "",
    service_id: "",
    sub_service_id: "",
    category_id: "",
    sub_type: "",
    sub_value: "",
    service_cost: "",
    service_charge: "",
    discount_type: "",
    discount_value: "",
    currency: "",
    category: "",
  });
  const {
    register,
    trigger,
    control,
    formState: { errors },
    setValue,
    reset,
    resetField,
  } = useForm({
    defaultValues: {
      plan_id: "",
      service_id: "",
      sub_service_id: "",
      category_id: "",
      sub_type: "",
      sub_value: "",
      service_cost: "",
      service_charge: "",
      discount_type: "",
      discount_value: "",
      currency: "",
      category: "",
    },
  });

  const [formFieldsValidation, setFormFieldsValidation] = useState({
    plan_id: {
      ...register("plan_id", { required: "This field is required" }),
    },
    service_id: {
      ...register("service_id", { required: "This field is required" }),
    },
    sub_service_id: {
      ...register("sub_service_id", { required: "This field is required" }),
    },
    // category_id: {
    //   ...register("category_id", { required: "This field is required" }),
    // },
    // sub_type: {
    //   ...register("sub_type", { required: "This field is required" }),
    // },
    // sub_value: {
    //   ...register("sub_value", { required: "This field is required" }),
    // },
    service_cost: {
      ...register("service_cost", { required: "This field is required" }),
    },
    service_charge: {
      ...register("service_charge", { required: "This field is required" }),
    },
    discount_type: {
      ...register("discount_type", { required: "This field is required" }),
    },
    discount_value: {
      ...register("discount_value", { required: "This field is required" }),
    },
    currency: {
      ...register("currency", { required: "This field is required" }),
    },
    category: {
      ...register("category", { required: "This field is required" }),
    },
  });

  const [planData, setPlanData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [subServiceData, setSubServiceData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    getPlanData();
    getServiceData();
    getSubServiceData();
    getCategoryData();
  }, []);

  const handleInput = (event, key) => {
    let value = event.target.value;
    console.log(value, key, "value");

    if (
      key === "service_cost" ||
      key === "service_charge" ||
      key === "discount_value"
    ) {
      value = Number.parseInt(value);
    }
    setValue(key, value);
    setFormFields({ ...formFields, [key]: value });
  };

  const handleSelect = (e, key) => {
    console.log(e, key, "value");
    setValue(key, e);
    setFormFields({ ...formFields, [key]: e });
  };

  const createCommercialData = async () => {
    console.log(await trigger());
    if (await trigger()) {
      let payload = {
        ...formFields,
        plan_id: formFields.plan_id.value,
        service_id: formFields.service_id.value,
        sub_service_id: formFields.sub_service_id.value,
        category_id: formFields.category_id.value,
      };
      // Object.keys(payload)
      let data = await dispatch(createCommercials(payload));
      if (data.payload) {
        console.log(data);
        toggle();
      }
    }
  };

  const editCommercialData = async () => {
    console.log(await trigger());
    if (await trigger()) {
      let payload = {};
      if (formFields?.sub_type != commercialData?.sub_type)
        Object.assign(payload, { sub_type: formFields?.sub_type });
      if (formFields?.sub_value != commercialData?.sub_value)
        Object.assign(payload, { sub_value: formFields?.sub_value });
      if (formFields?.service_cost != commercialData?.service_cost)
        Object.assign(payload, {
          service_cost: Number.parseInt(formFields?.service_cost),
        });
      if (formFields?.service_charge != commercialData?.service_charge)
        Object.assign(payload, {
          service_charge: Number.parseInt(formFields?.service_charge),
        });
      if (formFields?.discount_type != commercialData?.discount_type)
        Object.assign(payload, { discount_type: formFields?.discount_type });
      if (formFields?.discount_value != commercialData?.discount_value)
        Object.assign(payload, {
          discount_value: Number.parseInt(formFields?.discount_value),
        });

      if (formFields?.currency != commercialData?.currency)
        Object.assign(payload, { currency: formFields?.currency });

      let data = await dispatch(
        updateCommercials({ id: commercialData?.ID, payload: payload })
      );
      if (data.payload) {
        console.log(data, "data");
        toggle();
      }
    }
  };

  const getPlanData = async () => {
    let data = await dispatch(getAllPrograms());
    if (data?.payload?.length) {
      console.log(
        data.payload.map((a) => ({ label: a?.name, value: a.ID })),
        "Plan"
      );
      setPlanData(data.payload.map((a) => ({ label: a?.name, value: a.ID })));
    }
  };

  const getServiceData = async () => {
    let data = await dispatch(getAllServices());
    if (data?.payload?.length) {
      setServiceData(
        data.payload.map((a) => ({ label: a?.name, value: a.ID }))
      );
    }
  };
  const getSubServiceData = async () => {
    let data = await dispatch(getAllSubServices());
    if (data?.payload?.length) {
      setSubServiceData(
        data.payload.map((a) => ({ label: a?.name, value: a.ID }))
      );
    }
  };
  const getCategoryData = async () => {
    let data = await dispatch(getCategories());
    if (data?.payload?.length) {
      setCategoryData(
        data.payload.map((a) => ({ label: a?.name, value: a.ID }))
      );
    }
  };

  const setCommercialEditData = () => {
    let payload = {
      plan_id: planData.filter((a) => a.value === commercialData?.plan_id),
      service_id: serviceData.filter(
        (a) => a.value === commercialData?.service_id
      ),
      sub_service_id: subServiceData.filter(
        (a) => a.value === commercialData?.sub_service_id
      ),
      category_id: categoryData.filter(
        (a) => a.value === commercialData?.category_id
      ),
      sub_type: commercialData?.sub_type,
      sub_value: commercialData?.sub_value,
      service_cost: commercialData?.service_cost,
      service_charge: commercialData?.service_charge,
      discount_type: commercialData?.discount_type,
      discount_value: commercialData?.discount_value,
      currency: commercialData?.currency,
      category: commercialData?.category,
    };
    setFormFields(payload);
    Object.keys(payload).map((a) => {
      setValue(a, payload[a]);
    });
  };

  useEffect(() => {
    if (!isOpen) {
      reset();
      resetField();
      setFormFields({
        plan_id: "",
        service_id: "",
        sub_service_id: "",
        category_id: "",
        sub_type: "",
        sub_value: "",
        service_cost: "",
        service_charge: "",
        discount_type: "",
        discount_value: "",
        currency: "",
      });
    }
  }, [isOpen]);

  useEffect(() => {
    console.log(commercialData, "------->commerical");
    setCommercialEditData();
  }, [commercialData]);

  // console.log(planData,serviceData,subServiceData,)

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader>Create Commericial</ModalHeader>
      <ModalBody>
        <div className="px-2">
          <div className="d-flex gap-2 mt-4">
            <div className="w-full ">
              <Label>Plan Name</Label>
              <Select
                id="plan"
                options={planData}
                className="js-example-basic-single col-sm-12"
                onChange={(e) => handleSelect(e, "plan_id")}
                value={formFields.plan_id}
                // {...formFieldsValidation.plan_id}
              />
              {errors.plan_id && (
                <span className="mt-1 text-danger">
                  {errors.plan_id.message}
                </span>
              )}
            </div>
            <div className="w-full ">
              <Label>Service Name</Label>
              <Select
                id="service"
                options={serviceData}
                className="js-example-basic-single col-sm-12"
                onChange={(e) => handleSelect(e, "service_id")}
                isDisabled={false}
                value={formFields.service_id}
                // {...formFieldsValidation.service_id}
              />
              {errors.service_id && (
                <span className="mt-1 text-danger">
                  {errors.service_id.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Sub Service Name</Label>
              <Select
                id="subService"
                options={subServiceData}
                className="js-example-basic-single col-sm-12"
                onChange={(e) => handleSelect(e, "sub_service_id")}
                isDisabled={false}
                value={formFields.sub_service_id}
                required
                // {...formFieldsValidation.sub_service_id}
              />
              {errors.sub_service_id && (
                <span className="mt-1 text-danger">
                  {errors.sub_service_id.message}
                </span>
              )}
            </div>
            <div className="w-full">
              <Label>Category Name<span className="text-muted">(optional)</span></Label>
              <Select
                id="category"
                options={categoryData}
                className="js-example-basic-single col-sm-12"
                onChange={(e) => handleSelect(e, "category_id")}
                isDisabled={false}
                value={formFields.category_id}
                // {...formFieldsValidation.category_id}
              />
              {errors.category_id && (
                <span className="mt-1 text-danger">
                  {errors.category_id.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Sub Type<span className="text-muted">(optional)</span></Label>
              <Input
                name="sub_type"
                type="text"
                placeholder="Enter Sub Type"
                {...formFieldsValidation.sub_type}
                onChange={(event) => handleInput(event, "sub_type")}
                value={formFields.sub_type}
              />
              {errors.sub_type && (
                <span className="mt-1 text-danger">
                  {errors.sub_type.message}
                </span>
              )}
            </div>
            <div className="w-full">
              <Label>Sub Value<span className="text-muted">(optional)</span></Label>
              <Input
                name="sub_value"
                type="text"
                placeholder="Enter Sub Value"
                value={formFields.sub_value}
                {...formFieldsValidation.sub_value}
                onChange={(event) => handleInput(event, "sub_value")}
              />
              {errors.sub_value && (
                <span className="mt-1 text-danger">
                  {errors.sub_value.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Cost</Label>
              <Input
                name="service_cost"
                type="number"
                placeholder="Enter Cost"
                value={formFields.service_cost}
                {...formFieldsValidation.service_cost}
                onChange={(event) => handleInput(event, "service_cost")}
                required
              />
              {errors.service_cost && (
                <span className="mt-1 text-danger">
                  {errors.service_cost.message}
                </span>
              )}
            </div>
            <div className="w-full">
              <Label>Charges</Label>
              <Input
                name="service_charge"
                type="number"
                placeholder="Enter Cost"
                value={formFields.service_charge}
                {...formFieldsValidation.service_charge}
                onChange={(event) => handleInput(event, "service_charge")}
                required
              />
              {errors.service_charge && (
                <span className="mt-1 text-danger">
                  {errors.service_charge.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Discount Type</Label>
              <Input
                name="discount_type"
                type="text"
                placeholder="Enter Discount Type"
                value={formFields.discount_type}
                {...formFieldsValidation.discount_type}
                onChange={(event) => handleInput(event, "discount_type")}
                required
              />
              {errors.discount_type && (
                <span className="mt-1 text-danger">
                  {errors.discount_type.message}
                </span>
              )}
            </div>
            <div className="w-full">
              <Label>Discount Value</Label>
              <Input
                name="discount_value"
                type="number"
                placeholder="Enter Discount Value"
                value={formFields.discount_value}
                {...formFieldsValidation.discount_value}
                onChange={(event) => handleInput(event, "discount_value")}
                required
              />
              {errors.discount_value && (
                <span className="mt-1 text-danger">
                  {errors.discount_value.message}
                </span>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-4">
            <div className="w-full">
              <Label>Currency</Label>
              <Input
                name="currency"
                type="text"
                placeholder="Enter Currency"
                value={formFields.currency}
                {...formFieldsValidation.currency}
                onChange={(event) => handleInput(event, "currency")}
                required
              />
              {errors.currency && (
                <span className="mt-1 text-danger">
                  {errors.currency.message}
                </span>
              )}
            </div>
            <div className="w-full">
              <Label>Category</Label>
              <Input
                name="category"
                type="text"
                placeholder="Enter category"
                value={formFields.category}
                {...formFieldsValidation.category}
                onChange={(event) => handleInput(event, "category")}
                required
              />
              {errors.category && (
                <span className="mt-1 text-danger">
                  {errors.category.message}
                </span>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex customModalFooter">
        <button
          className="btn bg-primary"
          onClick={() => {
            if (commercialData != null && Object.keys(commercialData).length) {
              editCommercialData();
            } else {
              createCommercialData();
            }
          }}
        >
          {commercialData != null && Object.keys(commercialData).length
            ? "Edit"
            : "Create"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CommercialFormModal;
